import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { LinearProgress, useArrayInput, useGetList, useTranslate } from 'react-admin'
import { useWatch } from 'react-hook-form'
import { SectionLabel } from '~/components'
import { Sections } from '~/graphql/generated'
import { defaultSection } from './equipmentDefaults'

/**
 * "Bereich hinzufügen". Rendered inside the boat_section <ArrayInput>, and adds
 * through its append(): react-hook-form only counts a change as unsaved for a
 * registered field array, so a plain setValue left Save disabled.
 */
const ToolbarAddBoatSection = () => {
  const translate = useTranslate()
  const { append } = useArrayInput()
  const present: { section_id: number }[] = useWatch({ name: 'boat_section' }) ?? []

  const { data: sections, isLoading } = useGetList<Sections>('sections', {
    pagination: { page: 1, perPage: 25 },
    sort: { field: 'position', order: 'ASC' },
  })

  if (isLoading) return <LinearProgress />

  const available = (sections ?? []).filter((s) => !present.some((p) => p.section_id === s.id))
  return (
    <FormControl variant='outlined' margin='dense' fullWidth>
      <InputLabel id='section-label'>{translate('resources.sections.add')}</InputLabel>
      <Select
        labelId='section-label'
        label={translate('resources.sections.add')}
        value=''
        onChange={(e) => {
          const section = available.find((s) => s.id === Number(e.target.value))
          if (section) append(defaultSection(section))
        }}
      >
        {available.map((section) => (
          <MenuItem key={section.id} value={section.id}>
            <SectionLabel section={section} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default ToolbarAddBoatSection
